import './ItemButton.d5b97d0a9f419ea454c381424fbc7539.css';
export default {"button":"_button_gix4q_1"};